import React from "react";
import { Link } from "react-router-dom";

function NotFound() {
  return (
    <main className="not-found-page" style={{
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
      justifyContent: "center",
      minHeight: "60vh",
      textAlign: "center",
      padding: "2rem"
    }}>
      <h1 style={{ fontSize: "4rem", color: "#d4af37", marginBottom: "1rem" }}>404</h1>
      <h2 style={{ marginBottom: "1rem" }}>Page Not Found</h2>
      <p style={{ marginBottom: "2rem", color: "#ccc" }}>
        The page you're looking for doesn't exist or has been moved.
      </p>
      <Link
        to="/"
        style={{
          padding: "0.75rem 1.5rem",
          border: "2px solid #d4af37",
          backgroundColor: "#d4af37",
          color: "#000",
          borderRadius: "5px",
          fontWeight: "bold",
          textDecoration: "none"
        }}
      >
        Back to Home
      </Link>
    </main>
  );
}

export default NotFound;
